import React from "react"
import Moment from "react-moment"

import cx from "classnames"
import * as s from "./post-info.module.sass"

const PostInfo = (props) => {
  const { author, publishedDate, parentClass } = props

  const componentClass = cx({
    [s.component]: true,
    [parentClass]: parentClass,
  })

  return (
    <p className={componentClass}>
      <span className={s.author}>{author.name}</span>
      <Moment className={s.date} format="MMM Do YYYY">
        {publishedDate}
      </Moment>
    </p>
  )
}

export default PostInfo
